
<template>
  <div class="register_client">
    <crumbs>
      <i class="icon-stack2"></i>
      <span class="text">{{(actionType == "reg")?registerLan.crumbs.newaAccount:registerLan.crumbs.amend}}</span>
    </crumbs>
    <div class="content_box">
      <h2>{{registerLan.sales.title}}</h2>
      <div class="inputBox">
        <!-- 账户 -->
        <mimput class="col-lg-6" :col="12" :label="registerLan.sales.form.sales_id" :errBool="errors.has('sales_id')" :errTexrt="registerLan.flaseTipNum">
          <input name="sales_id" type="text" class="form-control col-lg-12" @keyup.enter="submitFn" v-validate="'required|numeric|max:11'" v-model="formMsgArr.sales_id" :class="{'input':true,'is-danger':errors.has('sales_id')}" ref="sales_id">
          <span v-show="user_id_point" class="errText-wrapper">
            <i class='glyphicon glyphicon-remove-circle errText'>{{registerLan.user_id_point}}</i>
          </span>
        </mimput>
        <!-- 用户名 -->
        <mimput class="col-lg-6" :col="12" :label='registerLan.sales.form.acc_name' :errBool="errors.has('user_name')" :errTexrt="registerLan.flaseTipName">
          <input name='user_name' @keyup.enter="submitFn"  type="text" class="form-control col-lg-12" v-validate="'required|max:45'" v-model='formMsgArr.user_name' ref="user_name">
          <span v-show="user_name_point" class="errText-wrapper">
            <i class='glyphicon glyphicon-remove-circle errText'>{{registerLan.user_name_point}}</i>
          </span>
        </mimput>
        <!-- 密码 -->
        <mimput class="col-lg-6" :col="12" :label='registerLan.sales.form.password' :errBool="errors.has('password')" :errTexrt="registerLan.flaseTipPass">
          <input @keyup.enter="submitFn" name='password' type="password" v-if="actionType == 'reg'" v-validate="'required|alpha_dash|min:1|max:256'" class="form-control col-lg-12" v-model='formMsgArr.password'>
          <input @keyup.enter="submitFn" name='password' type="password" v-if="actionType == 'change'" v-validate="'alpha_dash|min:1|max:256'" class="form-control col-lg-12" v-model='formMsgArr.password'>
        </mimput>
        <!-- 手机号 -->
        <mimput class="col-lg-6" :col="12" :label='registerLan.sales.form.phone' :errBool="errors.has('phone')" :errTexrt="registerLan.flasePhone">
          <input @keyup.enter="submitFn" type="text" name='phone' class="form-control col-lg-12" v-validate="'required|alpha_num|max:255'" v-model="formMsgArr.phone">
        </mimput>
        <!-- 邮件 -->
        <mimput class="col-lg-6" :col="12" :label='registerLan.sales.form.email' :errBool="errors.has('email')" :errTexrt="registerLan.flaseTip">
          <input @keyup.enter="submitFn" type="text" name='email' v-validate="'required|email'"
          class="form-control col-lg-12" v-model="formMsgArr.email" @input="validate_email">
          <div v-if="is_repeat_email" class="error">{{registerLan.email_isRepeat}}</div>
        </mimput>
        <!-- 权限级别 -->
        <mimput class="col-lg-6" :col="12" :label='registerLan.sales_info.form.jurisdiction.name'>
          <select name="qx" v-validate="'required'" class="dfinput form-control col-lg-12" @change="selectChange('jurisdictionActive')" v-model="jurisdictionActive">
            <option :value='jurisdictions[index]' v-for='(item,index) in jurisdictions'>{{item}}</option>
          </select>
          <!-- <input @keyup.enter="submitFn" name='remark' type="text" class="form-control col-lg-12" v-model="formMsgArr.remark"> -->
          <span v-show="errors.has('qx')" class="help-block">
            <i class='glyphicon glyphicon-remove-circle false'>{{registerLan.flaseTip}}</i>
          </span>
        </mimput>
        <!-- 备注 -->
        <mimput class="col-lg-6" :col="12" :label='registerLan.sales.form.remark'>
          <input @keyup.enter="submitFn" name='remark' type="text" class="form-control col-lg-12" v-model="formMsgArr.remark">
        </mimput>
      </div>
      <span class="input-group-btn">
        <button class="btn bg-teal" type="submit" @click="submitFn">{{actionType=="reg"?registerLan.submit:registerLan.changeBtn}}</button>
      </span>
    </div>
    <Modal v-model="modalShow" class="modal-content-j" size="sm" :header="false" :footer="false" :backdrop="!modalLink" @hide="toModalLink">
      <div :class="(modalBool?'color-green':'color-red')">
        <i class="glyphicon" :class="(modalBool?'glyphicon-ok':'glyphicon-warning-sign')"></i>
          <span>{{modalBool?registerLan.submitResult.succeed:registerLan.submitResult.err}}</span>
      </div>
      <div v-show="modalLink" @click="modalShow=false" class="btn btn-success btn-xs">{{registerLan.logOut.yes}}</div>
    </Modal>
  </div>
</template>
<script>
import crumbs from 'components/crumbs'
import mimput from 'components/mimput'
import  { URL_CREATEUSER, URL_FINDUSERID,URL_UPDATEUSER,URL_FINDALLROLE, URL_FINDUSER_BYEMAIL } from '../api/api.js'

export default {
  name: "userDatum",
  mixins: [
    require("common/mixin/base.js").base({registerLan:"userDatum"}),
    require("common/mixin/validate.js").validate(),
    require("common/mixin/modal.js").modal()
  ],
  data() {
    return {
      actionType: (this.$route.query.id || this.$route.query.id == 0)?"change":"reg",
      jurisdictions: [],
      jurisdictionActive: "customer_service",
      formMsgArr: {
        sales_id : '',
        user_name : '',
        password : '',
        phone : '',
        remark : '',
        email : '',
      },
      user_id_point:false,  //注册账号重复的提示
      user_name_point:false,//注册账号名重复的提示
      is_repeat_email: false
    }
  },
  mounted() {
    this.pegeInit()
    this.getAllRole()
    this.$refs.sales_id.disabled = this.actionType == "reg" ? false : true
    this.$refs.user_name.disabled = this.actionType == "reg" ? false : true
    setTimeout(() => {
      this.$refs.user_name.value = " "
    })
  },
  methods:{
    validate_email(event) {
      this.$http.post(URL_FINDUSER_BYEMAIL, {email: event.target.value}).then((res) => {
          let data = res.data;
          this.is_repeat_email = false
          if(data){
            this.is_repeat_email = true
          }
        })
    },
    pegeInit() {
      if(this.actionType == "change"){           //用户保存修改操作.
        let oId = this.$route.query.id;
        let userdata = {user_id : oId}
        this.$http.post(URL_FINDUSERID, userdata).then((res) => {
          let data = res.data;
          this.formMsgArr.sales_id=oId;
          this.formMsgArr.user_name = data.user_name;
          this.formMsgArr.phone = data.phone;
          this.formMsgArr.email = data.email;
          this.formMsgArr.remark = data.remark;
          this.jurisdictionActive = data.purview;
        })
      }
    },
    submitFn(){
      this.$validator.validateAll().then((result) => {
        if(this.is_repeat_email) return
        if (result) {
          this.$http.post(this.actionType == "change" ? URL_UPDATEUSER : URL_CREATEUSER, {
            type: this.actionType,
            user_id: this.formMsgArr.sales_id,
            password:  this.formMsgArr.password,
            user_name: this.formMsgArr.user_name,
            phone:  this.formMsgArr.phone,
            remark:  this.formMsgArr.remark,
            email:  this.formMsgArr.email,
            purview:  this.jurisdictionActive,
          }).then((res) => {
            if(res.data.code == '200'){
               this.modalLink = "/userList"
               this.modalBool = true
            }else if(res.data.code == '401'){
              this.user_id_point = true;
            }else if(res.data.code == '402'){
              this.user_name_point = true;
            }
            this.modalShow = true
          })
        }else{
          this.modalShow = true
        }
      })
    },
    selectChange(key) {
      this.getAllRole()
      this[key] = event.target.value
    },
    getAllRole(){
      this.jurisdictions = [];
      this.$http.get(URL_FINDALLROLE).then((res) => {
          let roles = res.data.data;
          roles.forEach(role => {
            this.jurisdictions.push(role["Role_ID"])
          });
        })
    }
 },
 watch: {
  'formMsgArr.sales_id'(curVal, oldVal) {
    this.user_id_point = false;
  },
   'formMsgArr.user_name'(curVal, oldVal) {
     this.user_name_point = false;
   }
},
components: {
  crumbs,
  mimput
}
}
</script>

<style lang='scss' type="text/scss" scoped>
.content_box {
  position: relative;
  margin: 0 20px 20px;
  padding: 20px 20px;
  border: 1px solid #ddd;
  background: #fff;
  h2 {
    line-height: 55px;
    margin-top: 0;
    margin-bottom: 20px;
    border-bottom: 1px solid #e5e5e5;
    font-size: 24px;
    font-weight: 700;
  }
  .inputBox {
    .error {
      color: #f44336;
    }
    overflow: hidden;
    .form-group {
      position: relative;
      height: 36px;
      margin-bottom: 40px;
      label {
        line-height: 40px;
        position: absolute;
        padding: 0;
        color: #000;
      }
      .inputbox {
        margin-left: 110px;
        position:relative;
        input[type='file'] {
          border: none;
          position: relative;
          z-index:99;
        }
        .date{
          position: absolute;
          right: 10px;
          top:0;
        }

        .row {
          position: relative;
          span.help-block {
            position: absolute;
            top:30px;
            &.passwordTip{
              top:-2px;;
              left:20px;
              z-index:0;
            }
          }
          span.file-help-block {
            position: absolute;
            top: 39px;
          }
          label.file-uploads {
            background: #eee;
            padding-left: 10px;
            padding-right: 10px;
            cursor: pointer;
            &:hover {
              background: #ccc;
            }
          }
          .fileName {
            position: absolute;
            min-width: 100px;
            max-width: 100px;
            height: 50px;
            top: -5px;
            left: 150px;
          }
        }
      }
    }
  }
  &:nth-of-type(3) {
    margin-bottom: 76px;
  }
  .input-group-btn {
    width: 100%;
    display: flex;
    button.btn {
      border-radius: 5px;
      position: absolute;
      top: 40px;
      left: 50%;
      padding: 7px 20px;
      transform: translateX(-50%);
      cursor: pointer;
      margin-bottom:20px;
    }
  }
}

.false {
  color: #f44336;
  font-size: 12px;
  &:before {
    position: relative;
    top: 1px;
    margin-right: 5px;
  }
}

.bg {
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
    align-items: center; // display: none;
    z-index: 10000;
    .tips {
      padding: 17px;
      width: 33.3%;
      background-color: #fff;
      text-align: center;
      border-radius: 5px;
      animation: show 0.3s;
      min-width: 100px;
      @keyframes show {
        0% {
          transform: scale(0.7);
          -webkit-transform: scale(0.7);
        }
        45% {
          transform: scale(1.05);
          -webkit-transform: scale(1.05);
        }
        80% {
          transform: scale(0.95);
          -webkit-transform: scale(0.95);
        }
        100% {
          transform: scale(1);
          -webkit-transform: scale(1);
        }
      }
      p {
        margin-top: 25px;
        margin-bottom: 20px;
        font-size: 16px;
        font-weight: 300;
        color: #797979;
      }
      button {
        padding: 10px 32px;
        margin-top: 26px;
        border-radius: 5px;
        background-color: rgb(140, 212, 245);
        font-size: 17px;
        font-weight: 500;
        cursor: pointer;
        color: #fff;
        border: none;
        outline: none;
        &:hover {
          background: rgb(134, 204, 235);
        }
      }
    }
  }

  </style>



// WEBPACK FOOTER //
// userDatum.vue?70169a38